import { Component, input, output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { DisplayValueModel } from '@plantefeve/common/models/display-value.model';
import { FloatLabelModule } from 'primeng/floatlabel';
import { Fluid } from 'primeng/fluid';
import { MultiSelectChangeEvent, MultiSelectModule } from 'primeng/multiselect';

@Component({
  selector: 'igx-multi-select',
  imports: [FloatLabelModule, FormsModule, ReactiveFormsModule, Fluid, MultiSelectModule],
  templateUrl: './multi-select.component.html',
})
export class MultiSelectComponent {
  public styleClass = input<string>();
  public valueFormControl = input<FormControl>();
  public model = input<any>();
  public label = input<string>();
  public options = input.required<DisplayValueModel[]>();
  public filter = input<boolean>(false);

  public onChange = output<MultiSelectChangeEvent>();

  public handleChange(event: MultiSelectChangeEvent): void {
    this.onChange.emit(event);
  }

  public get isRequired(): boolean {
    return this.valueFormControl()?.hasValidator(Validators.required) ?? false;
  }
}
